// services/couponService.js
import axios from "axios";
import { API_END_POINTS } from "../../../API_END_POINTS";

const footerPagesContent = `${process.env.REACT_APP_API_URL}${API_END_POINTS.FOOTER_PAGES_CONTENT}`;

// 🟢 Fetch Privacy Policy Content
export const privacyPolicyContentApi = async (api_token) => {
  try {
    const response = await axios.post(
      footerPagesContent,
      { id: 2 },
      {
        headers: {
          Authorization: `Bearer ${api_token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "An error occurred while fetching privacy policy content."
    );
  }
};

// 🟢 Fetch Terms & Conditions Content
export const termsAndConditionsContentApi = async (api_token, lang) => {
  try {
    const response = await axios.post(
      footerPagesContent,
      { id: 3 },
      {
        headers: {
          Authorization: `Bearer ${api_token}`,
          lang: lang,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "An error occurred while fetching terms and conditions content."
    );
  }
};

// 🟢 Fetch About Us Content
export const aboutUsContentApi = async (api_token, lang) => {
  try {
    const response = await axios.post(
      footerPagesContent,
      { id: 1 },
      {
        headers: {
          Authorization: `Bearer ${api_token}`,
          lang: lang,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "An error occurred while fetching terms and conditions content."
    );
  }
};

// 🟢 Fetch Terms & Conditions Content
export const refundPoliciesContentApi = async (api_token, lang) => {
  try {
    const response = await axios.post(
      footerPagesContent,
      { id: 5 },
      {
        headers: {
          Authorization: `Bearer ${api_token}`,
          lang: lang,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "An error occurred while fetching terms and conditions content."
    );
  }
};

// 🟢 Fetch return policy content
export const returnPoliciesContentApi = async (api_token, lang) => {
  try {
    const response = await axios.post(
      footerPagesContent,
      { id: 6 },
      {
        headers: {
          Authorization: `Bearer ${api_token}`,
          lang: lang,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "An error occurred while fetching terms and conditions content."
    );
  }
};

export const faqsContentApi = async (api_token, lang) => {
  const url = `${process.env.REACT_APP_API_URL}${API_END_POINTS.faqs}`;

  return await axios.post(url, {
    headers: {
      lang: lang,
      Authorization: `Bearer ${api_token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const askQuestionApi = async (formData) => {
  const url = `${process.env.REACT_APP_API_URL}${API_END_POINTS.ASK_A_QUESTION}`;

  return await axios.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const TestimonialDetails = async ({ api_token, lang }) => {
  const showProfileUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.testimonial}`;
  try {
    const response = await axios.get(showProfileUrl, {
      headers: {
        "Content-Type": "application/json",
        // authorization: `Bearer ${api_token}`,
        // lang: lang,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Something went wrong!";
  }
};
